import type { MassnahmeRow } from '@/core/data/massnahmen'
import type { ViewConfig } from '@/core/views/viewConfig'
import { formatDatum } from '@/core/lib/dates'

export type MassnahmeViewFilter = { durchfForm: string[] }
export const EMPTY_MASSNAHME_VIEW_FILTER: MassnahmeViewFilter = { durchfForm: [] }

function metaParts(m: MassnahmeRow, ueSum?: number): (string | null)[] {
  const ueZulassung = [
    m.ue_anzahl != null ? `${ueSum ?? 0}/${m.ue_anzahl} UE` : null,
    m.ende_zulassung ? `bis ${formatDatum(m.ende_zulassung)}` : null,
  ]
    .filter((x): x is string => !!x)
    .join(', ')
  return [m.nummer || null, ueZulassung || null]
}

export function massnahmeMeta(m: MassnahmeRow, ueSum?: number): string {
  return metaParts(m, ueSum)
    .filter((x): x is string => !!x)
    .join(' · ')
}

export const massnahmeViewConfig: ViewConfig<MassnahmeRow> = {
  rowKey: (m) => m.id,
  title: (m) => m.bezeichnung || "(ohne Bezeichnung)",
  cards: true,
  emptyText: "Keine Maßnahmen konfiguriert",
  sortKeys: [
    { key: 'bezeichnung', label: "Bezeichnung", accessor: (m) => m.bezeichnung || '' },
    { key: 'nummer', label: "Nummer", accessor: (m) => m.nummer || '' },
    { key: 'ue', label: "UE", accessor: (m) => m.ue_anzahl ?? 0 },
  ],
  searchFields: (m) => [m.bezeichnung, m.nummer],
  filterCategories: [
    {
      id: 'durchfForm',
      label: "Form",
      catalog: () => [
        { key: 'einzel', label: "Einzel" },
        { key: 'gruppe', label: "Gruppe" },
      ],
      accessor: (m) => m.durchf_form,
    },
  ],
}

export function massnahmeViewConfigWithUeSums(ueSums: Map<string, number>): ViewConfig<MassnahmeRow> {
  return {
    ...massnahmeViewConfig,
    properties: [{ id: 'meta', value: (m: MassnahmeRow) => massnahmeMeta(m, ueSums.get(m.id)) }],
  }
}

export const massnahmeViewConfigMinimal: ViewConfig<MassnahmeRow> = {
  ...massnahmeViewConfig,
  properties: [{ id: 'meta', value: (m: MassnahmeRow) => m.nummer || '' }],
  sortKeys: massnahmeViewConfig.sortKeys!.filter((k) => k.key !== 'ue'),
}
